module.exports = __webpack_public_path__ + "img/activate-header-background.ed67e267.png";